module.exports = __webpack_public_path__ + "media/images/front/icons/icon_white_cart-91c4727e09b8495d90cbc6d629044ac6.svg";